export default __webpack_public_path__ + "static/media/mask.3b947481.jpg";